export const appModes = {
  pro: "pro",
  standard: "standard",
};
export const appMode = localStorage.getItem("app_mode");
const standardEndpoint = process.env.REACT_APP_API_STANDARD_ENDPOINT;
export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
const apiEndPoint = standardEndpoint;

export const API_CONFIG = {
  login: `${apiEndPoint}/v3/user/login`,
  logout: `${apiEndPoint}/v1/user/logout`,
  profile: `${apiEndPoint}/v3/user/profile`,
  subscriptionProfile: `${apiEndPoint}/v1/user/subscription/profile`,
  purchasePlans: `${apiEndPoint}/v2/payment/products`,
  newPurchasePlans: `${apiEndPoint}/v3/payment/monthly-products`,
  signup: `${apiEndPoint}/v3/user/signup`,
  forgetPassword: `${apiEndPoint}/v1/user/forget-password`,
  resetPassword: `${apiEndPoint}/v1/user/reset-password`,
  traversal: `${apiEndPoint}/v3/traversal`,
  traversalActual: `${apiEndPoint}/v3/traversal/actual`,
  payment: `${apiEndPoint}/v3/payment/transact`,
  paymentPublic: `${apiEndPoint}/v3/payment/transact/public`,
  changePassword: `${apiEndPoint}/v1/user/change-password`,
  verifyEmail: `${apiEndPoint}/v3/user/email/verify`,
  couponCodeApply: `${apiEndPoint}/v3/coupon/validate`,
  subscribedPlans: `${apiEndPoint}/v3/user/get-subscription`,
  locationList: `${apiEndPoint}/v2/center`,
  countryList: `${apiEndPoint}/v4/countries`,
};